export default "__VITE_ASSET__314ec3ee__"